import '../../../../common/css/style.css';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p>&copy; {currentYear} Made by Maks Fedorenchik. All rights reserved.</p>
    </footer>
  );
};
